<template>

  <div class="sorting-wrapper">

    <div class="sorting-select">
      <Select
          optionLabel="title"
          unstyled
          v-model="sortData"
          :options="sortingItems"
          input-class="sorting-result"
          panel-class="sorting-dropdown"
          @change="sortHotelsProducts"
      >
        <!-- slot value -->
        <template #value="option">
          <span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8" stroke="#595757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="sorting-label">{{t('Sort by')}}:
              {{ option.value.labelTitle }}
            </span>
          </span>
        </template>

        <template #option="slotProps">
          <div class="sorting-option">
            {{slotProps.option.title}}
          </div>
        </template>
      </Select>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { useSearchStore } from '~/store/search'
import Select from 'primevue/select';

const router = useRouter()
const route = useRoute()
const searchStore = useSearchStore()
const emit = defineEmits(['update'])
const { t } = useI18n()

const dynamicSortingItems = [
  {title: 'Featured', labelTitle: 'Featured', value: 'rating_desc'},
  {title: 'Price (Low to High)', labelTitle: 'Lowest Price', value: 'price_asc'},
  {title: 'Price (High to Low)', labelTitle: 'Highest Price', value:  'price_desc'},
]

const staticSortingItems = [
  {title: 'Featured', value: 'rating_desc', labelTitle: 'Featured'},
  {title: 'Name', value: 'name_asc', 'labelTitle': 'Name'},
]

// Dynamically switch between sorting options based on mode
const sortingItems = computed(() => {
  return searchStore.isDynamicHotels ? dynamicSortingItems : staticSortingItems
})

const DEFAULT_DYNAMIC_SORTING = dynamicSortingItems[0]
const DEFAULT_STATIC_SORTING = staticSortingItems[0]

const sortData = ref(DEFAULT_DYNAMIC_SORTING)

const getDefaultSortingItem = (isDynamic: boolean) => (isDynamic ? DEFAULT_DYNAMIC_SORTING : DEFAULT_STATIC_SORTING)

const syncSortData = (sort: unknown, isDynamic: boolean) => {
  const availableItem = sortingItems.value.find(item => item.value === sort)

  if (availableItem) {
    sortData.value = availableItem
    return
  }

  sortData.value = getDefaultSortingItem(isDynamic)

  if (!sort) {
    return
  }

  const query = { ...route.query }
  delete query.sort
  router.replace({ query })
}

onMounted(() => {
  syncSortData(route.query.sort, searchStore.isDynamicHotels)
})

watch(
  [() => searchStore.isDynamicHotels, () => route.query.sort],
  ([isDynamic, currentSort]) => {
    syncSortData(currentSort, isDynamic)
  }
)

//methods
function sortHotelsProducts(_type: any) {
  const type = _type?.value?.value

  let query = Object.assign({}, router.currentRoute.value.query)


  if (type){
    query.sort = type
  } else {
    delete query.sort
  }

  router.push({query: query})
  emit('update', type)
}

</script>



<style scoped lang="scss">

.sorting-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  .sorting-select {
    border-radius: 10px;
    background: var(--light-grey);
    padding: 8px 12px;
    align-items: center;

    @media screen and (max-width: 768px) {
      width: 100%;
      background: transparent;
    }

    > div, .sorting-result {
      display: flex;
      text-align: center;
      width: 100%;
      justify-content: space-between;
      gap: 8px;

      >span {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        color: var(--dark-grey);
      }


    }

  }

  .sorting-label {
    color: var(--black);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    white-space: nowrap;

  }
}
</style>

<style>
.sorting-dropdown {
  border: 1px solid var(--grey);
  border-radius: 8px;
  background: var(--white);
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.06);
  padding: 12px 0;
}

.sorting-option {
  padding: 10px 28px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--black);
  cursor: pointer;

  font-size: 16px;
  font-weight: 400;
  line-height: 150%;

  &:hover {
    background: var(--light-grey);
  }
}
</style>
